import { render, staticRenderFns } from "./Citasview.vue?vue&type=template&id=fa14eb08&scoped=true"
import script from "./Citasview.vue?vue&type=script&lang=js"
export * from "./Citasview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa14eb08",
  null
  
)

export default component.exports